import "../css/hero.css";

function Hero() {
  return (
    <div className="hero-div">
      <h1 className="heroHeadline">
        Get Pre-Approved Before You Start House Hunting.
      </h1>
      <p className="heroP">
        Find out what you may qualify for, understand your monthly payment
        range, and get a clear plan for your home purchase.
      </p>
      <a
        href="https://firstclasshomemortgage.my1003app.com/102983/register"
        target="_blank"
        rel="noreferrer"
        className="buttonBlue heroButton"
      >
        Start My Pre-Approval
      </a>
    </div>
  );
}

export default Hero;
